import { useCallback, useState } from 'react';

const WARNING_SHAKE_DURATION = 400;

const useTermsAgreement = (agreementLink?: string) => {
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [isAgreementOpened, setAgreementOpened] = useState(false);
  const [isWarningShaking, setWarningShaking] = useState(false);

  const handleOpenAgreement = useCallback(() => {
    if (agreementLink) {
      window.open(agreementLink, '_blank', 'noopener,noreferrer');
    }
    setAgreementOpened(true);
  }, [agreementLink]);

  const triggerWarningShake = useCallback(() => {
    setWarningShaking(true);
    setTimeout(() => setWarningShaking(false), WARNING_SHAKE_DURATION);
  }, []);

  const resetTermsAgreement = useCallback(() => {
    setTermsAccepted(false);
    setAgreementOpened(false);
    setWarningShaking(false);
  }, []);

  return {
    termsAccepted,
    isAgreementOpened,
    isWarningShaking,
    setTermsAccepted,
    handleOpenAgreement,
    triggerWarningShake,
    resetTermsAgreement,
  };
};

export default useTermsAgreement;
